import React from "react"
import useActivePromotion from "@helpers/useActivePromotion"
import SaleSvg from "@svgs/sale.svg"

// Shows the active Dato promotion's badge, or the default sale teardrop
const SaleBadge = () => {
  const activePromo = useActivePromotion()

  if (activePromo?.badge?.url) {
    return <img src={activePromo.badge.url} alt={activePromo.name} />
  }

  return <SaleSvg />
}

export default SaleBadge
